import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect, useRef } from 'react';
import DateFormatter from 'cleave.js/src/shortcuts/DateFormatter';
import { getNextCursorPosition } from '../utils';
import { Input } from './Input';
import { createEasyInput } from './EasyInput';
var minimumDate = '1900-01-01';
var maximumDate = '2099-12-31';
var minimumDateFormatted = '01/01/1900';
export var getRawMaxLength = function (pattern) {
    var formatter = new DateFormatter(pattern, minimumDate, maximumDate);
    var blocks = formatter.getBlocks();
    return blocks.reduce(function (sum, block) { return sum + block; }, 0);
};
var formatDate = function (pattern, delimiter, dateString) {
    if (dateString === void 0) { dateString = ''; }
    var formatter = new DateFormatter(pattern, minimumDate, maximumDate);
    var tmpDate = formatter.getValidatedDate("" + dateString);
    return formatter.getBlocks().reduce(function (str, blockLength, index, blockArr) {
        var block = tmpDate.substring(0, blockLength);
        var isYearZero = index === 2 && block === '0000';
        if (!block) {
            return str;
        }
        tmpDate = tmpDate.substring(blockLength);
        var shouldAppendDelimiter = block.length === blockLength && index < blockArr.length - 1;
        return isYearZero ? minimumDateFormatted : "" + str + block + (shouldAppendDelimiter ? delimiter : '');
    }, '');
};
export var DateInput = function (_a) {
    var delimiter = _a.delimiter, pattern = _a.pattern, forwardedRef = _a.forwardedRef, initialValue = _a.initialValue, propValue = _a.value, onKeyDown = _a.onKeyDown, onChange = _a.onChange, inputProps = __rest(_a, ["delimiter", "pattern", "forwardedRef", "initialValue", "value", "onKeyDown", "onChange"]);
    var format = function (value) { return formatDate(pattern, delimiter, value); };
    var _b = __read(useState(initialValue || format(propValue)), 2), currentValue = _b[0], setValue = _b[1];
    var inputRef = forwardedRef || useRef();
    var previousValue = useRef(propValue);
    useEffect(function () {
        if (previousValue.current !== propValue && propValue !== currentValue) {
            setValue(format(propValue));
        }
        previousValue.current = propValue;
    }, [propValue]);
    var handleKeyDown = function (event) {
        var isLetterLike = /^\w{1}$/.test(event.key);
        if (isLetterLike && currentValue.replace(/\D/g, '').length >= getRawMaxLength(pattern)) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    var handleChange = function (name, newValue, event) {
        var nextValue = newValue.length < currentValue.length ? newValue.trim() : format(newValue);
        var nextCursorPosition = getNextCursorPosition(event.target.selectionStart, currentValue, nextValue);
        setValue(nextValue);
        setTimeout(function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(nextCursorPosition, nextCursorPosition);
        });
        if (onChange) {
            onChange(name, nextValue, event);
        }
    };
    return (React.createElement(Input, __assign({ forwardedRef: inputRef, value: currentValue, onKeyDown: handleKeyDown, onChange: handleChange }, inputProps)));
};
DateInput.defaultProps = __assign(__assign({}, Input.defaultProps), { pattern: ['m', 'd', 'Y'], delimiter: '/' });
export default createEasyInput(DateInput);
//# sourceMappingURL=DateInput.js.map